module.exports = __webpack_public_path__ + "img/Sri Lanka.0f822557.svg";